module.exports = __webpack_public_path__ + "img/culture.ebd8e33c.png";